<script lang="ts">
    import {Icon} from 'svelma';
    import {createEventDispatcher} from "svelte";

    export let data;
    export let type;
    const dispatch = new createEventDispatcher();

    let highlight = false;

    function onClick() {
        dispatch('infoClick', {
            data: data,
            type: type
        });
    }
</script>

<div class="icon-element"
     class:highlight={highlight}
     on:click={onClick}
     on:mouseenter={()=>highlight=true}
     on:mouseleave={()=>highlight=false}
>
    <Icon pack="fa" size="is-medium" icon="info-circle"/>
</div>


<style>
    .icon-element {opacity: 0.5}

    .highlight {
        opacity: 1;
        cursor: pointer;
    }
</style>
